module.exports = {"id":"159591","name":"Andrés Pérez","rating":"75","photo":"./data/images/photos/1/159591.png","club":{"name":"Deportivo Cali","logo":"./data/images/clubs/DeportivoCali.png"},"positions":["MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndresPerez0.json
// module id = 394
// module chunks = 0